
import React from 'react'
import { Grid } from '@mui/material';
import { CustomChip } from '../../../components/chip/Chip';

export const TabsHeader = ({ tabs, handleClickTab, notificacionesLoading, indicationsLoading, runQuery }) => {
    return (
        <Grid
            container
            spacing={1}
        >
            {tabs.map((tab, index) =>
                <Grid
                    key={index}
                    size={{ md: 1.8, xs: 3 }}
                    className={tab.active ? 'tabActive' : 'tabsHeader'}
                    onClick={() => (notificacionesLoading || indicationsLoading) ? null : handleClickTab(tab.id, runQuery)}
                    sx={{ cursor: 'pointer' }}
                >
                    <p className='tabName'> {tab.name} </p>
                    <CustomChip
                        label={tab.count}
                        isGreen={tab.active}
                        sx={{ marginLeft: '5px', borderRadius: '50%', padding: '2px' }}
                    />
                </Grid>
            )}
        </Grid>
    )
}
